import { BASE_URL } from "./Constant";

export let base_url_API = BASE_URL + "userAuth/api/admin/";

//---------Auth Module---------
export const Login_API = base_url_API + 'login';
export const ViewProfile_API = base_url_API + 'viewProfile';
export const Forgot_API = base_url_API + 'forgotPassword';
export const UpdateProfile_API = base_url_API + 'updateProfile';
export const Logout_API = BASE_URL + "userAuth/api/logout";

//---------Master Data Module---------
export const AllPrograms_API = BASE_URL + 'adminPrograms/api/allPrograms';
export const UpdateActiveStatus_API = BASE_URL + 'adminPrograms/api/updateIsActiveStatus';
export const ViewProgramDetails_API = BASE_URL + 'adminPrograms/api/viewProgram';
export const GuestListForProgram_API = BASE_URL + 'adminPrograms/api/getGuestListForProgram';
export const GetAnandaProgramLevels_API = BASE_URL + 'adminPrograms/api/getAnandaProgramLevels';

//-----------User Management---------
export const ByPassOTP_API = BASE_URL + '/adminUserManagement/api/updateOtpVerifiedStatus';
export const AllGuest_API = BASE_URL + 'adminUserManagement/api/getGuestUsersData';
export const ViewGuestDetails_API = BASE_URL + 'adminUserManagement/api/viewGuestDetails';
export const AddNewGuest_API = BASE_URL + 'adminUserManagement/api/addNewGuest';
export const UpdateGuestDetails_API = BASE_URL + 'adminUserManagement/api/updateGuestDetailsByAdmin';
export const DeleteGuestProfile_API = BASE_URL + 'userAuth/api/admin/deleteGuestProfile';

//---------Assessment ---------
export const AllAssessment_API = BASE_URL + 'adminPrograms/api/getSectionsMasterData';
export const ViewAssessment_API = BASE_URL + 'adminPrograms/api/getQuestionsBySection';

//---------Team Member Module ---------
export const GetDepartmentList_API = BASE_URL + 'adminUserManagement/api/getDepartmentList';
export const TeamMembersList_API = BASE_URL + 'adminUserManagement/api/getTeamMembersList';
export const addTeamMember_API = BASE_URL + 'adminUserManagement/api/addNewTeamMember';
export const deleteTeamMember_API = BASE_URL + 'adminUserManagement/api/deleteUser';
export const getUSerRoleList_API = BASE_URL + 'adminUserManagement/api/getUserRoleList';
export const getTeamMemberDetails_API = BASE_URL + 'adminUserManagement/api/viewTeamUserDetailById';
export const updateTeamMemberDetails_API = BASE_URL + 'adminUserManagement/api/updateTeamUserDetailById';
export const updateMultipleUserRole_API = BASE_URL + 'adminUserManagement/api/bulkUpdateUserRole';

//---------User Role Module ---------

export const addNewUserRole_API = BASE_URL + 'adminUserManagement/api/addNewUserRole';
export const deleteUserRole_API = BASE_URL + 'adminUserManagement/api/deleteUserRole';
export const updateUserRole_API = BASE_URL + 'adminUserManagement/api/updateUserRoleTitle';

//---------Access Management Module ---------
export const accessManagementList_API = BASE_URL + 'adminUserManagement/api/accessManagementList';
export const updateAccess_API = BASE_URL + 'adminUserManagement/api/updateAccess';

//---------Recipe Collection Module ---------
export const getRecipeCollectionList_API = BASE_URL + 'adminPrograms/api/getRecipeCollectionList';
export const addNewRecipeCollection_API = BASE_URL + 'adminPrograms/api/addNewRecipeCollection';
export const ViewRecipeCollectionForEdit_API = BASE_URL + 'adminPrograms/api/viewRecipeCollectionById';
export const editRecipeCollection_API = BASE_URL + 'adminPrograms/api/updateRecipeCollectionById';
export const getRecipe_API = BASE_URL + 'adminPrograms/api/getRecipeListByCollectionId';
export const viewRecipeDetailsById_API = BASE_URL + 'adminPrograms/api/getRecipeDetailsById';
export const addNewRecipe_API = BASE_URL + 'adminPrograms/api/addNewRecipe';
export const updateRecipe_API = BASE_URL + 'adminPrograms/api/updateRecipeById';

//--------- Master Data Module Delete Common APi ---------
export const masterDataModuleDelete_API = BASE_URL + 'adminPrograms/api/delete';

//--------Content Management------
export const ViewProgramsList_API = BASE_URL + 'adminPrograms/api/getAnandaProgramList';
export const ViewCategoryList_API = BASE_URL + 'adminContentManagement/api/getContentCategories';
export const ContentsList_API = BASE_URL + 'adminContentManagement/api/getContentList';
export const ViewContentDetails_API = BASE_URL + 'adminContentManagement/api/getContentDetailById';
export const AddVideoPodcast_API = BASE_URL + 'adminContentManagement/api/addContent';
export const UpdateVideoPodcast_API = BASE_URL + 'adminContentManagement/api/updateContentById';
export const ViewContentsList_API = BASE_URL + 'adminContentManagement/api';

export const DeleteContent_API = BASE_URL + 'adminPrograms/api/delete';

export const GetAllAnnouncement_API = BASE_URL + 'notifications/api/getListOfAnnouncementOffers';
export const ViewAnnouncement_API = BASE_URL + 'notifications/api/getAnnouncementDetails';
export const AddAnnouncement_API = BASE_URL + 'notifications/api/addAnnouncementOffers';
export const UpdateAnnouncement_API = BASE_URL + 'notifications/api/updateAnnouncementOffers';
export const DeleteAnnouncement_API = BASE_URL + 'notifications/api/deleteAnnouncementOffers';


//--------Content Category------
export const getContentCategoryList_API = BASE_URL + 'adminPrograms/api/getContentCategoryList';


//--------Upload File API Common For All------
export const uploadFile_API = BASE_URL + 'api/upload/file';

export const update_Program_Req_API = BASE_URL + '/adminPrograms/api/sendUpdateRequestToDev';

//--------Activity For All------
export const getActivity_API = BASE_URL + 'adminPrograms/api/getInHouseActivityList';
export const viewActivity_API = BASE_URL + 'adminPrograms/api/getInHouseActivityDetailsById';
export const interestedGuestList_API = BASE_URL + 'adminPrograms/api/interestedGuestList';
export const addActivity_API = BASE_URL + 'adminPrograms/api/addNewInHouseActivity';
export const updateActivity_API = BASE_URL + 'adminPrograms/api/updateInHouseActivityById';


//--------Testinomial------
export const getTestimonials_API = BASE_URL + 'adminReportsManagement/api/reports/getTestimonialList';
export const updateTestimonialStatus_API = BASE_URL + 'adminReportsManagement/api/reports/updateTestimonialStatus';


//--------Program Feedback------
export const getProgramFeedbacks_API = BASE_URL + 'adminReportsManagement/api/reports/getFeedbackList';
export const viewProgramFeedbacks_API = BASE_URL + 'adminReportsManagement/api/reports/viewFeedbackDetails';

//--------Guest Dinacharya------
export const getGuestDinacharyas_API = BASE_URL + 'adminReportsManagement/api/reports/getDinacharyaProgressList';
export const viewGuestDinacharya_API = BASE_URL + 'adminReportsManagement/api/reports/userDincharyaProgressReport';

//--------QMS dashboard------
export const getQMSDashboardData_API = BASE_URL + 'adminReportsManagement/api/reports/getFeedbackReport';

//--------QMS Feedback Detail------
export const getQMSFeedbackDetail_API = BASE_URL + 'adminReportsManagement/api/reports/getFeedbackDetailedReport';
export const downloadQMSFeedbackDetail_API = BASE_URL + 'adminReportsManagement/api/reports/csv/getFeedbackDetailedReport';


//--------Guest Comment------
export const getGuestComments_API = BASE_URL + 'adminReportsManagement/api/reports/getGuestComments';

//--------Consultant Rating------
export const getConsultantRatings_API = BASE_URL + 'adminReportsManagement/api/reports/getConsultantRating';
export const downloadConsultantRatingsExcel_API= BASE_URL + 'adminReportsManagement/api/reports/csv/getConsultantRating'

//--------Query Report------
export const getAnandaKeyCategory_API = BASE_URL + 'adminReportsManagement/api/reports/anandaKeyCategory';
export const getReportForQuery_API = BASE_URL + 'adminReportsManagement/api/reports/customQuery';
export const downloadReportForQuery_API = BASE_URL + 'adminReportsManagement/api/reports/downloadReport';
export const getSampleDataForCategory_API = BASE_URL + 'adminReportsManagement/api/reports/getExampleDataForCustomQuery';
export const getLabTest_API = BASE_URL + 'wellness/notes/api/getLabMasterData';
export const getLabTestCategory_API = BASE_URL + 'wellness/notes/api/getLabTestCategories';

//--------Therapist Sessions------
export const get_therapist_list_API= BASE_URL + 'wellness/session/api/therapistList';
export const get_recommendations_API= BASE_URL + 'wellness/session/api/sessionList/therapist';
export const download_recommendation_excel_API= BASE_URL + 'wellness/session/api/sessionList/csv/therapist'

//--------User Manual------
export const getUserManual_API = BASE_URL + 'adminUserManagement/api/viewAnandaDocs';
export const updateUserManual_API = BASE_URL + 'adminUserManagement/api/addUpdateAnandaDocs';
export const deleteUserManual_API = BASE_URL + 'adminUserManagement/api/deleteAnandaDocs';


//--------Delete Request------
export const getDeletedReqUsers_API = BASE_URL + 'adminUserManagement/api/getDeletedReqUsers';
export const recoverAccount_API = BASE_URL + 'adminUserManagement/api/recoverAccount';
export const deleteAccountPermanently_API = BASE_URL + 'adminUserManagement/api/deleteAccountPermanently';